<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue"

const props = defineProps<{
    title: string,
    show_section?: boolean,
}>()

const time = ref("")
const day = ref("")
const date = ref("")

function updateTime() {
    const now = new Date()
    time.value = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    day.value = now.toLocaleDateString([], { weekday: "long" })
    date.value = now.toLocaleDateString([], { month: "long", day: "2-digit", year: "numeric" })
}

onMounted(() => {
  updateTime() // set immediately
  const interval = setInterval(updateTime, 1000) // update every second
  onUnmounted(() => clearInterval(interval))
})
</script>

<template>
    <div class="monitor-header">
            <p class="monitor-header-title">
                <span v-if="props.show_section">Reseller</span>
                {{props.title}}
            </p>

            <div class="monitor-date-time-container">
                <div class="monitor-date-container">
                    <p class="monitor-day">{{day}}</p>
                    <p class="monitor-date">{{date}}</p>
                </div>
                <p class="monitor-time">{{time}}</p>
            </div>
        </div>
</template>

<style scoped lang="scss">
.monitor-header {
        height: 23rem;
        background: rgba(0, 178, 169, .1);
        border-radius: 8rem;
        padding: 0 7.6rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .monitor-header-title {
            color: var(--color-white);
            @include font(6.9, 6.9, black);

            span {
                display: block;
                @include font(3.1,3.1,book);
                color: #009991;
            }
        }

        .monitor-date-time-container {
            display: flex;
            align-items: center;
            gap: 5.2rem;

            .monitor-date-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 1.3rem;

                .monitor-day {
                    @include font(4.9,4.9,book);
                    color: var(--color-white);
                }
                .monitor-date {
                    @include font(3.2,3.2,black);
                    color: var(--color-white);
                }
            }
        }

        .monitor-time {
            color: #009991;
            @include font(12.6,12.6,book);
        }
    }
</style>
